import {Pipe, PipeTransform} from '@angular/core';

/** Пайп экранирует html-теги, но сохраняет спецсимволы */
@Pipe({
    name: 'escapeHtml',
    standalone: true
})
export class EscapeHtmlPipe implements PipeTransform {
    transform(value: string): string {
        return value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            // Снятие экранирования для специальных HTML символов, если они были экранированы
            .replace(/&amp;(#(?:x[0-9A-Fa-f]+|\d+)|[A-Za-z]+);/g, '&$1;');
    }
}
